import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Calendar, MapPin, Check } from "lucide-react";
import { api } from "../lib/api";
import { PageHero, Empty } from "../components/ui-parts";
import { ODISHA_DISTRICTS } from "../lib/districts";

export default function Programmes() {
  const [status, setStatus] = useState("");
  const [district, setDistrict] = useState("");
  const [list, setList] = useState([]);
  const [reg, setReg] = useState(null);
  const [form, setForm] = useState({ full_name: "", mobile: "", email: "", district: "" });
  const [done, setDone] = useState(null);

  useEffect(() => { api.get("/programmes", { params: { status: status || undefined, district: district || undefined } }).then(r => setList(r.data)); }, [status, district]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/programme-registrations", { ...form, programme_id: reg.id });
      setDone(data.ref); toast.success(`Registered! ${data.ref}`);
    } catch (err) { toast.error("Registration failed"); }
  };

  return (
    <div data-testid="programmes-page">
      <PageHero badge="Events" title="Programmes & Events" subtitle="Sanskrit camps, workshops, cultural gatherings and future programmes across Odisha." />
      <section className="section">
        <div className="container-narrow">
          <div className="flex flex-wrap gap-3 mb-6">
            <select value={status} onChange={e => setStatus(e.target.value)} data-testid="prog-status" className="px-3 py-2 rounded-full border border-[var(--js-border)] bg-white text-sm">
              <option value="">All</option><option value="upcoming">Upcoming</option><option value="ongoing">Ongoing</option><option value="completed">Completed</option>
            </select>
            <select value={district} onChange={e => setDistrict(e.target.value)} data-testid="prog-district" className="px-3 py-2 rounded-full border border-[var(--js-border)] bg-white text-sm">
              <option value="">All districts</option>{ODISHA_DISTRICTS.map(d => <option key={d}>{d}</option>)}
            </select>
          </div>
          {list.length === 0 ? <Empty title="No programmes match" /> :
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {list.map(p => (
                <div key={p.id} className="js-card p-6" data-testid={`prog-${p.id}`}>
                  <div className="text-xs text-[var(--js-secondary)] font-semibold uppercase mb-2">{p.status}</div>
                  <div className="font-heading text-lg text-[var(--js-primary)]">{p.name}</div>
                  <div className="text-sm text-[var(--js-muted)] mt-2 flex items-center gap-2"><Calendar size={13} /> {p.date} {p.time && `· ${p.time}`}</div>
                  <div className="text-sm text-[var(--js-muted)] flex items-center gap-2"><MapPin size={13} /> {p.venue || p.district}</div>
                  <p className="text-sm mt-3 line-clamp-3">{p.description}</p>
                  <button onClick={() => { setReg(p); setDone(null); }} className="js-btn-outline mt-4 !py-1.5 !px-4 !text-xs" data-testid={`prog-reg-${p.id}`}>Register</button>
                </div>
              ))}
            </div>
          }
        </div>
      </section>

      {reg && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setReg(null)}>
          <div className="js-card p-6 max-w-md w-full" onClick={e => e.stopPropagation()} data-testid="prog-reg-modal">
            <h3 className="font-heading text-xl text-[var(--js-primary)] mb-4">Register for {reg.name}</h3>
            {done ? <div className="text-center py-6"><Check size={32} className="mx-auto text-[var(--js-accent)]" /><p className="mt-2 font-semibold">Registered!</p><p className="text-sm text-[var(--js-muted)] mt-1">Ref:</p><p className="font-mono text-[var(--js-primary)]">{done}</p></div> :
              <form onSubmit={submit} className="space-y-3">
                {[["full_name", "Full Name"], ["mobile", "Mobile"], ["email", "Email"]].map(([k, l]) => (
                  <input key={k} required type={k === "email" ? "email" : "text"} placeholder={l} value={form[k]} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} className="w-full px-3 py-2 rounded-md border border-[var(--js-border)] text-sm" data-testid={`prog-${k}`} />
                ))}
                <select required value={form.district} onChange={e => setForm(f => ({ ...f, district: e.target.value }))} className="w-full px-3 py-2 rounded-md border border-[var(--js-border)] text-sm" data-testid="prog-form-district">
                  <option value="">District</option>{ODISHA_DISTRICTS.map(d => <option key={d}>{d}</option>)}
                </select>
                <button className="js-btn-primary w-full justify-center" data-testid="prog-submit">Register</button>
              </form>
            }
          </div>
        </div>
      )}
    </div>
  );
}
